import React from 'react';
import "../css/index.css"
// import styles from "../css/styles.css";


export default class SelectBox extends React.Component {

    createItems() {
        let items = [];
        // console.log("columns = ",this.props.columns);
        // console.log("columns = ",this.props.columns[0]);
        //let selected = selected="selected";
        //var selectedValue = "selected";
        if(this.props.defaultId === undefined){
            items.push( <option key="" value="">Select</option>)
        }
        if(this.props.columns !== undefined && this.props.keys !== undefined){
            // console.log("keys =",this.props.keys[0]);

        if(this.props.columns != null){         
            for (let i = 0; i < this.props.columns.length; i++) {
            // console.log("values =",this.props.columns[i][this.props.keys[1]]);
            //    if(this.props.defaultId !== undefined &&
            //     this.props.defaultId === this.props.columns[i][this.props.keys[0]]){

            //         console.log("this.props.defaultId =",this.props.defaultId);
            //         //selectedValue = true;
            //     }
            /* selected={this.props.defaultId !== undefined &&
                        this.props.defaultId === this.props.columns[i][this.props.keys[0]]  } */
            // defaultValue={this.props.defaultId !== undefined &&
            //     this.props.defaultId === this.props.columns[i][this.props.keys[0]] ?
            //     this.props.columns[i][this.props.keys[1]]
            //     : ""}
                items.push(
                    <option key = {this.props.columns[i][this.props.keys[0]]}
                        value = {this.props.columns[i][this.props.keys[0]]}

                        selected={this.props.defaultId !== undefined &&
                        this.props.defaultId === this.props.columns[i][this.props.keys[0]]  }

                        >
                        {this.props.columns[i][this.props.keys[1]]}
                    </option>);
            }
        }
        }
        else if(this.props.keys === undefined){
            for (let i = 0; i < this.props.columns.length; i++) {

             items.push(
                 <option key = {this.props.columns[i]}
                     value = {i}>
                     {this.props.columns[i]}
                 </option>);
         }

        }
        return items;
    }

    render(){
        let selectBox = "";
        if(this.props.selectBoxDisabled !== undefined && this.props.selectBoxDisabled === "disabled" ){
            selectBox =  <select id={this.props.labeltxt} onChange={this.props.selectBoxcallBack}
                 style={this.props.style} disabled="disabled" >
            {this.createItems()}
           </select>

        }
        else {
            selectBox =  <select id={this.props.labeltxt} onChange={this.props.selectBoxcallBack}  style={this.props.style}
           >
            {this.createItems()}
           </select>
        }


        return(
            <div><label for={this.props.labeltxt}>{this.props.labeltxt}</label>
        <p>{selectBox}</p></div>
        );

    }

}
